import { EventListPresenterRequest } from "../../contracts";
import { EventsResponse } from "sb-resp-lib";

export const isDifferentResponse = (request: EventListPresenterRequest, response: EventsResponse) => {
    if (!response.events || !response.events.length) {
        return false;
    }

    if (request.eventTags && request.eventTags.length && response.events[0].tags) {
        return response.events[0].tags.indexOf(request.eventTags[0]) === -1;
    }

    return checkDateRangeAndSportId(request, response);
};

const isDifferentDateRange = (request: EventListPresenterRequest, response: EventsResponse) => {
    if (request.dateRange) {
        return response.events && response.events.some(ev => {
            let date = new Date(ev.startEventDate ? ev.startEventDate : 0);
            return date < request.dateRange.from || date >= request.dateRange.to;
        });
    }
    return false;
}

const checkDateRangeAndSportId = (request: EventListPresenterRequest, response: EventsResponse) => {
    let dateRangeCheck = isDifferentDateRange(request, response);
    return dateRangeCheck || request.ids.indexOf(response.events && response.events[0].sportId) === -1;
}